import React from 'react';
import { Button } from '@blueprintjs/core';
import { processType } from 'constants/process-type';
import { ShowIf } from 'components/utils';
import { browserHistory } from 'react-router';
import { ConfirmDialog } from 'modules/handle-letters/dialog';
import { CheckQuyenThaoTacXuLy } from 'modules/login/CheckQuyenThaoTacXuLy';
import { validatable } from 'components/utils';
import classnames from 'classnames';

class ButtonGroup extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      hideBtn: false,
      haveDialog: false,
      openDialog: false,
      contentDialog: '',
      btnName: '',
      buttonShow: false,
      btnProccess: false
    }
  }

  onChange(state) {

    this.props.onChange(state);
  }

  // Gan ten cho button theo quy trinh
  componentWillReceiveProps(nextProps) {

    if ((nextProps.alias && this.props.alias != nextProps.alias) ||
      (this.props.params != nextProps.params)) {
      let ttxmText = this.props.donInfo.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'thẩm tra xác minh';
      switch (nextProps.alias) {
        case 'WordProcessingOperatorAction':
          if (nextProps.params) {
            if (nextProps.params.nextState) {
              if (nextProps.params.nextState.type == processType.xuLyDon.processing.trinhLanhDao) {
                this.setState({
                  btnName: 'Trình',
                  hideBtn: false
                })

                return;
              }

              if (nextProps.params.nextState.type == processType.xuLyDon.processing.trinhTruongPhong) {
                this.setState({
                  btnName: 'Trình',
                  hideBtn: false
                })

                return;
              }

              if (nextProps.params.nextState.type == processType.xuLyDon.processing.yeuCauGapLanhDao) {
                this.setState({
                  btnName: 'Chuyển yêu cầu',
                  hideBtn: false
                })

                return;
              }
            } else {
              this.setState({
                hideBtn: true
              })
            }
          }
          break;
        case 'ManagerAction':
          if (nextProps.params) {
            if (nextProps.params.nextState) {
              this.setState({
                btnName: 'Giao việc',
                hideBtn: false
              })

              return;
            } else {
              this.setState({
                hideBtn: true
              })
            }
          }
        break;
        case 'LeaderAction':
          if (nextProps.params) {
            if (nextProps.params.nextState && typeof nextProps.params.huongXuLy == 'undefined') {
              this.setState({
                btnName: 'Giao việc',
                hideBtn: false,
                buttonShow: true,
                haveDialog: false,
                btnProccess: false
              })
              return;
            } else if (nextProps.params.huongXuLy) {

              switch (nextProps.params.huongXuLy) {
                case processType.xuLyDon.huongXuLy.deXuatThuLy:
                  if (nextProps.params.trangThaiTTXM === "TU_TTXM") {
                    this.setState({
                      btnName: 'Chuyển giải quyết đơn',
                      haveDialog: true,
                      contentDialog: null,
                      btnProccess: true,
                      buttonShow: true,
                      hideBtn: false,
                      truongPhongXLD: true
                    })

                  } else if (nextProps.params.trangThaiTTXM === "GIAO_TTXM") {

                    this.setState({
                      btnName: 'Chuyển đơn vị '+ttxmText,
                      haveDialog: true,
                      contentDialog: 'Bạn có đồng ý chuyển đơn/vụ việc này cho ' + nextProps.params.donViThamTraXacMinhTen + ' '+ttxmText+' không?',
                      btnProccess: false,
                      buttonShow: false,
                      hideBtn: false
                    })

                  } else {

                    this.setState({
                      btnProccess: true,
                      buttonShow: false
                    })
                  }
                break;
                case processType.xuLyDon.huongXuLy.chuyenDon:
                  let tenCoQuan = '';
                  let thamQuyenHanhChinhId = localStorage.getItem('thamQuyenHanhChinhId') || 0;
                  if (typeof nextProps.params.thamQuyenGiaiQuyet != 'undefined' && nextProps.params.thamQuyenGiaiQuyet.id == thamQuyenHanhChinhId && nextProps.params.coQuanTiepNhan) {
                    tenCoQuan = nextProps.params.coQuanTiepNhan ? nextProps.params.coQuanTiepNhan.ten : '';
                    this.setState({
                      btnName: 'Chuyển đơn',
                      haveDialog: true,
                      contentDialog: 'Bạn có đồng ý chuyển đơn/vụ việc này cho ' + tenCoQuan + ' giải quyết không?',
                      btnProccess: false,
                      buttonShow: false,
                      hideBtn: false
                    });
                  } else if (typeof nextProps.params.thamQuyenGiaiQuyet != 'undefined' && nextProps.params.thamQuyenGiaiQuyet.id != thamQuyenHanhChinhId) {
                    this.setState({
                      btnName: 'Lưu hồ sơ',
                      haveDialog: true,
                      contentDialog: 'Bạn có muốn lưu hồ sơ này?',
                      btnProccess: false,
                      buttonShow: false,
                      hideBtn: false
                    });
                  } else {
                    this.setState({
                      hideBtn: true
                    });
                  }
                break;
                case processType.xuLyDon.huongXuLy.traDonChuyenKhongDungThamQuyen:
                  let noticeTraDon = 'Bạn có đồng ý trả đơn/vụ việc này cho ' + nextProps.thongTinXuLyGiaiQuyet.coQuanChuyenDon.ten + ' giải quyết không?';
                  this.setState({
                    btnName: 'Trả đơn chuyển',
                    haveDialog: true,
                    contentDialog: noticeTraDon,
                    btnProccess: false,
                    buttonShow: false,
                    hideBtn: false
                  });
                break;
                case processType.xuLyDon.huongXuLy.yeuCauGapLanhDao:
                  this.setState({
                    haveDialog: false,
                    btnName: 'Gửi yêu cầu',
                    btnProccess: false,
                    hideBtn: false
                  });
                break;
                default:
                  this.setState({
                    btnName: 'Lưu hồ sơ',
                    haveDialog: true,
                    contentDialog: 'Bạn sẽ không thể thực hiện bất kỳ thao tác nào với đơn này. Bạn có muốn Lưu hồ sơ?',
                    btnProccess: false,
                    buttonShow: false,
                    hideBtn: false
                  });
                break;
              }
            } else {
              this.setState({
                hideBtn: true,
                buttonShow: false
              });
            }
          }
        break;
        case 'XuLyDonTuXuLy':
        case 'WordProcessingSpecialistAction':
          if (nextProps.params) {
            if (nextProps.params.huongXuLy) {
              switch (nextProps.params.huongXuLy) {
                case processType.xuLyDon.huongXuLy.deXuatThuLy:
                  if (nextProps.alias === 'WordProcessingSpecialistAction' || nextProps.alias === 'XuLyDonTuXuLy' || nextProps.alias === 'WordProcessingSpecialistActionNoProcess') {

                    if (nextProps.params.trangThaiTTXM === "TU_TTXM") {
                      this.setState({
                        btnName: 'Chuyển giải quyết đơn',
                        haveDialog: true,
                        contentDialog: null,
                        chuyenVienXLD: true,
                        btnProccess: true,
                        buttonShow: true,
                        hideBtn: false
                      })
                    } else if (nextProps.params.trangThaiTTXM === "GIAO_TTXM") {
                      this.setState({
                        btnName: 'Chuyển đơn vị '+ttxmText,
                        haveDialog: true,
                        contentDialog: 'Bạn có đồng ý chuyển đơn/vụ việc này cho ' + nextProps.params.donViThamTraXacMinhTen + ' '+ttxmText+' không?',
                        btnProccess: false,
                        buttonShow: false,
                        hideBtn: false
                      })
                    } else {
                      this.setState({
                        btnProccess: true,
                        buttonShow: false
                      })
                    }
                  } else {
                    this.setState({
                      haveDialog: false,
                      btnProccess: false,
                      buttonShow: false,
                      hideBtn: false
                    })
                  }
                break;
                case processType.xuLyDon.huongXuLy.chuyenDon:
                  let tenCoQuan = '';
                  let thamQuyenHanhChinhId = localStorage.getItem('thamQuyenHanhChinhId') || 0;
                  if (typeof nextProps.params.thamQuyenGiaiQuyet != 'undefined' && nextProps.params.thamQuyenGiaiQuyet.id == thamQuyenHanhChinhId && nextProps.params.coQuanTiepNhan) {
                    tenCoQuan = nextProps.params.coQuanTiepNhan ? nextProps.params.coQuanTiepNhan.ten : '';
                    this.setState({
                      btnName: 'Chuyển đơn',
                      haveDialog: true,
                      contentDialog: 'Bạn có đồng ý chuyển đơn/vụ việc này cho ' + tenCoQuan + ' giải quyết không?',
                      btnProccess: false,
                      buttonShow: false,
                      hideBtn: false
                    });
                  } else if (typeof nextProps.params.thamQuyenGiaiQuyet != 'undefined' && nextProps.params.thamQuyenGiaiQuyet.id != thamQuyenHanhChinhId) {
                    this.setState({
                      btnName: 'Lưu hồ sơ',
                      haveDialog: true,
                      contentDialog: 'Bạn có muốn lưu hồ sơ này?',
                      btnProccess: false,
                      buttonShow: false,
                      hideBtn: false
                    });
                  } else {
                    this.setState({
                      hideBtn: true
                    });
                  }
                break;
                case processType.xuLyDon.huongXuLy.traDonChuyenKhongDungThamQuyen:
                  let noticeTraDon = 'Bạn có đồng ý trả đơn/vụ việc này cho ' + nextProps.thongTinXuLyGiaiQuyet.coQuanChuyenDon.ten + ' giải quyết không?';
                  this.setState({
                    btnName: 'Trả đơn chuyển',
                    haveDialog: true,
                    contentDialog: noticeTraDon,
                    btnProccess: false,
                    buttonShow: false,
                    hideBtn: false
                  });
                break;
                case processType.xuLyDon.huongXuLy.yeuCauGapLanhDao:
                  this.setState({
                    haveDialog: false,
                    btnName: 'Gửi yêu cầu',
                    btnProccess: false,
                    hideBtn: false
                  });
                break;
                default:
                  this.setState({
                    btnName: 'Lưu hồ sơ',
                    haveDialog: true,
                    contentDialog: 'Bạn sẽ không thể thực hiện bất kỳ thao tác nào với đơn này. Bạn có muốn Lưu hồ sơ?',
                    btnProccess: false,
                    buttonShow: false,
                    hideBtn: false
                  });
                break;
              }
            } else {
              this.setState({
                hideBtn: true,
                buttonShow: false
              });
            }
          }
        break;
        case 'WordProcessingSpecialistActionNoProcess':
          if (nextProps.params) {
            if (nextProps.params.huongXuLy) {
              switch (nextProps.params.huongXuLy) {
                case processType.xuLyDon.huongXuLy.deXuatThuLy:
                  if (nextProps.params.trangThaiTTXM === "TU_TTXM") {
                    this.setState({
                      btnName: 'Chuyển giải quyết đơn',
                      haveDialog: false,
                      btnProccess: true,
                      buttonShow: true,
                      hideBtn: false
                    })
                  } else if (nextProps.params.trangThaiTTXM === "GIAO_TTXM") {
                    this.setState({
                      btnName: 'Chuyển đơn vị '+ttxmText,
                      haveDialog: true,
                      contentDialog: 'Bạn có đồng ý chuyển đơn/vụ việc này cho ' + nextProps.params.donViThamTraXacMinhTen + ' '+ttxmText+' không?',
                      btnProccess: false,
                      buttonShow: false,
                      hideBtn: false
                    })
                  } else {
                    this.setState({
                      btnProccess: true,
                      buttonShow: false
                    })
                  }
                break;
                case processType.xuLyDon.huongXuLy.chuyenDon:
                  let tenCoQuan = '';
                  let thamQuyenHanhChinhId = localStorage.getItem('thamQuyenHanhChinhId') || 0;
                  if (typeof nextProps.params.thamQuyenGiaiQuyet != 'undefined' && nextProps.params.thamQuyenGiaiQuyet.id == thamQuyenHanhChinhId && nextProps.params.coQuanTiepNhan) {
                    tenCoQuan = nextProps.params.coQuanTiepNhan ? nextProps.params.coQuanTiepNhan.ten : '';
                    this.setState({
                      btnName: 'Chuyển đơn',
                      haveDialog: true,
                      contentDialog: 'Bạn có đồng ý chuyển đơn/vụ việc này cho ' + tenCoQuan + ' giải quyết không?',
                      btnProccess: false,
                      buttonShow: false,
                      hideBtn: false
                    });
                  } else if (typeof nextProps.params.thamQuyenGiaiQuyet != 'undefined' && nextProps.params.thamQuyenGiaiQuyet.id != thamQuyenHanhChinhId) {
                    this.setState({
                      btnName: 'Lưu hồ sơ',
                      haveDialog: true,
                      contentDialog: 'Bạn có muốn lưu hồ sơ này?',
                      btnProccess: false,
                      buttonShow: false,
                      hideBtn: false
                    });
                  } else {
                    this.setState({
                      hideBtn: true
                    });
                  }
                break;
                case processType.xuLyDon.huongXuLy.traDonChuyenKhongDungThamQuyen:
                  let noticeTraDon = 'Bạn có đồng ý trả đơn/vụ việc này cho ' + nextProps.thongTinXuLyGiaiQuyet.coQuanChuyenDon.ten + ' giải quyết không?';
                  this.setState({
                    btnName: 'Trả đơn chuyển',
                    haveDialog: true,
                    contentDialog: noticeTraDon,
                    btnProccess: false,
                    buttonShow: false,
                    hideBtn: false
                  })
                break;
                case processType.xuLyDon.huongXuLy.yeuCauGapLanhDao:
                  this.setState({
                    haveDialog: false,
                    btnName: 'Gửi yêu cầu',
                    btnProccess: false,
                    hideBtn: false
                  })
                break;
                default:
                  this.setState({
                    btnName: 'Lưu hồ sơ',
                    haveDialog: true,
                    contentDialog: 'Bạn sẽ không thể thực hiện bất kỳ thao tác nào với đơn này. Bạn có muốn Lưu hồ sơ?',
                    btnProccess: false,
                    buttonShow: false,
                    hideBtn: false
                  })
                break;
              }
            } else {
              this.setState({
                hideBtn: true,
                buttonShow: false
              })
            }
          }
        break;
        case 'CanBoNhapLieuGiaiQuyetDonAction':
          this.setState({
            btnName: 'Chuyển'
          })
        break;
        case 'CanBoNhapLieuTTXMAction':
          this.setState({
            btnName: 'Trình'
          })
        break;
        case 'LanhDaoTTXMAction':
          if (nextProps.params) {
            if (nextProps.params.paramsPost) {
              if (nextProps.params.paramsPost.nextState) {
                this.setState({
                  btnName: 'Giao việc',
                  hideBtn: false
                })
              } else {
                this.setState({
                  hideBtn: true
                })
              }
            } else {
              this.setState({
                hideBtn: true
              })
            }
          } else {
            this.setState({
              hideBtn: true
            })
          }
        break;
        case 'vanThuKiemTraDeXuat':
          this.setState({
            btnName: 'Trình'
          })
        break;
        case 'lanhDaoKiemTraDeXuat':
          this.setState({
            btnName: 'Giao việc'
          })
        break;
        case 'CanBoTTXMKhongQuyTrinh':
        case 'CanBoTTXMAction':
          let noticeCanBoTTXMAction = 'Bạn có đồng ý chuyển cho ' + (this.props.thongTinXuLyGiaiQuyet.donViGiaoThamTraXacMinhInfo ? this.props.thongTinXuLyGiaiQuyet.donViGiaoThamTraXacMinhInfo.ten : '') + ' báo cáo '+ttxmText+' của đơn/vụ việc này không?';
          let lb1 = this.props.donInfo.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'TTXM';
          this.setState({
            btnName: 'Gửi báo cáo '+lb1+' cho đơn vị giao',
            haveDialog: true,
            contentDialog: noticeCanBoTTXMAction,
            btnProccess: false,
            buttonShow: false,
            hideBtn: false
          })
        break;
        default:
        break;
      }
    }
  }

  // Mo confirm dialog
  openDialog(name) {
    if (this.props.validateSubmitForm()) {

      this.setState({
        openDialog: true
      })
    }
  }

  // Dong confirm dialog
  closeDialog() {
    this.setState({
      openDialog: false
    })
  }

  // Di den chinh sua don/vu viec
  goEdit(donId) {
    browserHistory.push('/xu-ly-don/chinh-sua/' + donId);
  }

  postProcess() {
    if (this.props.processType === 'XU_LY_DON' || this.props.alias === 'XuLyDonTuXuLy') {
      if (this.state.haveDialog && (this.props.alias === 'XuLyDonTuXuLy' ||
          this.props.alias === 'WordProcessingSpecialistAction' ||
          ((this.props.alias === 'WordProcessingSpecialistActionNoProcess' || this.props.alias === 'LeaderAction') && this.props.params.huongXuLy === processType.xuLyDon.huongXuLy.deXuatThuLy) ||
          ((this.props.alias === 'WordProcessingSpecialistActionNoProcess' || this.props.alias === 'LeaderAction') && this.props.params.huongXuLy === processType.xuLyDon.huongXuLy.chuyenDon))
      ) {
        if(this.props.validateSubmitForm()) {
          this.openDialog();
        }
      } else {
        if (this.props.alias === 'XuLyDonTuXuLy') {
          this.props.onClickTuXuLy('BC_XLD');
        } else if (this.props.alias === 'LeaderAction') {
          this.props.onClickXuLyDon('BC_XLD');
        } else {
          this.props.onClickXuLyDon();
        }
      }
    } else if (this.props.processType === 'THAM_TRA_XAC_MINH' || this.props.processType === 'KIEM_TRA_DE_XUAT') {
      this.props.onClickGiaiQuyet();
    }
  }

  onClickXuLyDon() {
    if (this.props.alias === 'XuLyDonTuXuLy' || this.props.alias === 'WordProcessingSpecialistAction' || this.props.alias === 'WordProcessingSpecialistActionNoProcess') {
      this.props.onClickXuLyDon('BC_XLD');
    } else if (this.props.alias === 'LeaderAction') {
      this.props.onClickXuLyDon('BC_XLD');
    } else {
      this.props.onClickXuLyDon();
    }
  }

  onClickTuXuLy() {
    if (this.props.alias === 'XuLyDonTuXuLy' || this.props.alias === 'WordProcessingSpecialistAction' || this.props.alias === 'WordProcessingSpecialistActionNoProcess') {
      this.props.onClickTuXuLy('BC_XLD');
    } else {
      this.props.onClickTuXuLy();
    }
  }


  patchProcess(isLuutam) {
    if (this.props.alias === 'XuLyDonTuXuLy') {
      if (this.props.alias === 'WordProcessingSpecialistAction' || this.props.alias === 'WordProcessingSpecialistActionNoProcess') {
        this.props.patchTuXuLy('BC_XLD');
      } else {
        this.props.patchTuXuLy();
      }
    } else if (this.props.processType === 'XU_LY_DON') {
      if (this.props.alias === 'WordProcessingSpecialistAction' || this.props.alias === 'WordProcessingSpecialistActionNoProcess') {
        this.props.patchXuLyDon('BC_XLD');
      } else if (this.props.alias === 'LeaderAction') {
        this.props.patchXuLyDon('BC_XLD');
      } else {
        this.props.patchXuLyDon();
      }
    } else if (this.props.processType === 'THAM_TRA_XAC_MINH' ||
      this.props.processType === 'KIEM_TRA_DE_XUAT') {
      this.props.patchGiaiQuyetDon(!isLuutam);
    } else if (this.props.processType === 'XULYDONCU') {
      this.props.onSave();
    }
  }

  render() {
    return (
      <div className="action-form-wrap no-gutter">
        <div className="box-bottom">
          <Button type="button" name="closebt" className="btn-action btn-close action-todo" onClick={this.props.onClose}>Đóng</Button>
          <ShowIf condition={this.props.pageType === 'THEM_MOI_VA_CHINH_SUA_DON'}>
            <ShowIf condition={!this.props.lanhDaoDuyet}>
              <Button
                type="button"
                className={this.props.btnLoading ?
                  (this.props.btnSaveLoading && this.props.btnSaving ? "btn-action btn-save btn-green btn-loading-inline" :
                    'btn-action btn-save btn-green btn-disable') : "btn-action btn-save btn-green"}
                onClick={this.props.onSave}>Lưu tạm</Button>
            </ShowIf>

            <ShowIf condition={this.props.alias != 'WordProcessingSpecialistActionNoProcess' || (this.props.alias === 'WordProcessingSpecialistActionNoProcess' && this.props.params.huongXuLy != processType.xuLyDon.huongXuLy.deXuatThuLy)}>
              <ShowIf condition={this.props.donDangXuLy && !this.state.hideBtn}>
                <Button type="button" className={this.props.btnLoading ?
                  (this.props.btnSaveLoading && this.props.btnSaving ?
                    "btn-action btn-move btn-green btn-disable" : 'btn-action btn-move btn-green btn-loading-inline') :
                  "btn-action btn-move btn-green right"} onClick={this.props.onClickXuLyDon}>{this.state.btnName}</Button>
              </ShowIf>
            </ShowIf>

            <ShowIf condition={(this.props.alias === 'WordProcessingSpecialistActionNoProcess' && this.props.params.huongXuLy == processType.xuLyDon.huongXuLy.deXuatThuLy)}>

              <ShowIf condition={this.props.donDangXuLy && !this.state.hideBtn && !this.state.btnProccess}>
                <Button type="button" className={this.props.btnLoading ?
                  (this.props.btnSaveLoading ? "btn-action btn-move btn-green btn-disable right" :
                    'btn-action btn-move btn-green btn-loading-inline right') : "btn-action btn-move btn-green right"}
                  onClick={this.postProcess.bind(this)}>{this.state.btnName}</Button>
              </ShowIf>

              <ShowIf condition={this.props.donDangXuLy && !this.state.hideBtn && this.state.btnProccess}>
                <Button type="button" className={this.props.btnLoading ?
                  (this.props.btnSaveLoading ? "btn-action btn-move btn-green btn-disable right" :
                    'btn-action btn-move btn-green btn-loading-inline right') : "btn-action btn-move btn-green right"}
                  onClick={this.props.onClickXuLyDon}>{this.state.btnName}</Button>
              </ShowIf>

              <ShowIf condition={this.state.haveDialog}>
                <ConfirmDialog
                  alias={this.props.alias}
                  title="Xác nhận"
                  params={this.props.params}
                  open={this.state.openDialog}
                  onClose={this.closeDialog.bind(this)}
                  onSuccess={this.onClickXuLyDon.bind(this)}
                  content={this.state.contentDialog}
                  bindValidator={this}
                  btnSaveLoading={this.props.btnSaveLoading}
                  btnLoading={this.props.btnLoading}
                  onChange={this.onChange.bind(this)}
                  type="XLD"
                  buttonShow={this.state.buttonShow}
                  validateSubmitForm={this.props.validateSubmitForm}
                />
              </ShowIf>
            </ShowIf>
          </ShowIf>
          <ShowIf condition={this.props.alias === 'DONCU'}>
            <Button type="button" className={classnames('btn-action btn-save btn-green', {'btn-loading-inline' :this.props.btnSaveLoading, 'btn-disable':this.props.btnLoading})}
              onClick={this.patchProcess.bind(this, true)}>Lưu</Button>
          </ShowIf>
          <ShowIf condition={CheckQuyenThaoTacXuLy(this.props.canBoDangXuLy) || this.props.alias === 'XuLyDonTuXuLy'}>
            <ShowIf condition={this.props.pageType === 'CHI_TIET_DON' }>
              <ShowIf condition={!this.props.lanhDaoDuyet && this.props.trangThaiDonDonVi !== undefined && this.props.trangThaiDonDonVi.ketQuaType !== 'DINH_CHI' && !this.props.donInfo.hoanThanhDon && this.props.donInfo.thongTinGiaiQuyetDonInfo && !this.props.donInfo.thongTinGiaiQuyetDonInfo.ketQuaXLDGiaiQuyet}>
                <Button type="button" className="btn-action btn-edit btn-green" onClick={this.goEdit.bind(this, this.props.donId)}>Sửa</Button>
              </ShowIf>

              <ShowIf condition={this.props.donDangXuLy || this.props.alias === 'XuLyDonTuXuLy'}>
                <Button type="button" className={'btn-action btn-save btn-green '+ (this.props.btnSaveLoading ? 'btn-loading-inline' : (this.props.btnLoading ? 'btn-disable' : ''))}
                  onClick={this.patchProcess.bind(this, true)}>Lưu tạm</Button>
              </ShowIf>

              <ShowIf condition={(this.props.alias === 'XuLyDonTuXuLy' || this.props.donDangXuLy) && !this.state.hideBtn && !this.state.btnProccess}>
                <Button type="button" className={'btn-action btn-move btn-green right '+ (this.props.btnLoading ? 'btn-loading-inline' : (this.props.btnSaveLoading ? 'btn-disable' : ''))} onClick={this.postProcess.bind(this)}>{this.state.btnName}</Button>
              </ShowIf>

              <ShowIf condition={this.state.buttonShow && this.props.alias === 'WordProcessingSpecialistActionNoProcess'}>
                <Button type="button" className={'btn-action btn-move btn-green right '+ (this.props.btnLoading ? 'btn-loading-inline' : (this.props.btnSaveLoading ? 'btn-disable' : ''))} onClick={this.onClickXuLyDon.bind(this)}>Chuyển giải quyết đơn</Button>
              </ShowIf>

              <ShowIf condition={this.props.donDangXuLy && this.props.trangThaiDonDonVi && this.props.trangThaiDonDonVi.trangThaiDonType ==='DANG_XU_LY'}>
                <Button type="button" className="btn-action btn-edit btn-green" onClick={this.goEdit.bind(this, this.props.donId)}>Sửa</Button>
              </ShowIf>
              <ShowIf condition={this.state.haveDialog}>
                <ConfirmDialog
                  alias={this.props.alias}
                  title="Xác nhận"
                  params={this.props.params}
                  open={this.state.openDialog}
                  onClose={this.closeDialog.bind(this)}
                  onSuccess={this.onClickXuLyDon.bind(this)}
                  onTuXuLy={this.onClickTuXuLy.bind(this)}
                  content={this.state.contentDialog}
                  bindValidator={this}
                  btnSaveLoading={this.props.btnSaveLoading}
                  btnLoading={this.props.btnLoading}
                  onChange={this.onChange.bind(this)}
                  type="XLD"
                  truongPhongXLD={this.state.truongPhongXLD}
                  chuyenVienXLD={this.state.chuyenVienXLD}
                  buttonShow={this.state.buttonShow}
                  validateSubmitForm={this.props.validateSubmitForm}
                  onClickSaveFile={this.props.onClickSaveFile}
                />
              </ShowIf>
            </ShowIf>
          </ShowIf>

        </div>
      </div>
    )
  }
}

ButtonGroup.defaultProps = {
  donInfo: {}
}

export default validatable(ButtonGroup);



// WEBPACK FOOTER //
// ./src/components/modules/handle-letters/button-group/ButtonGroup.jsx